export default __webpack_public_path__ + "static/media/playAudio.5f64ed73.svg";